export default "__VITE_ASSET__B_FQ4he6__"